import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ValidationModalDto = {
  isShapeValid?: boolean;
  showModal?: boolean;
  overlappingIssue?: boolean;
  outOfBoundariesIssue?: boolean;
  localizationMissingIssue?: boolean;
  shouldSkipCallToLocalization?: boolean;
};

type State = {
  validationModalData: ValidationModalDto;
};

const initialState: State = {
  validationModalData: {
    showModal: false,
    overlappingIssue: false,
    outOfBoundariesIssue: false,
    localizationMissingIssue: false
  }
};

const annotationValidationModalSlice = createSlice({
  name: 'annotationValidationModal',
  initialState,
  reducers: {
    setValidationData(state, action: PayloadAction<ValidationModalDto>) {
      state.validationModalData = action.payload;
    }
  }
});

export const { setValidationData } = annotationValidationModalSlice.actions;
export default annotationValidationModalSlice.reducer;
